import Immutable from 'immutable';
import store from 'store2';
import { push } from 'react-router-redux';

const LOAD = 'auth/LOAD';
const LOAD_SUCCESS = 'auth/LOAD_SUCCESS';
const LOAD_FAIL = 'auth/LOAD_FAIL';
const LOGIN = 'auth/LOGIN';
const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
const LOGIN_FAIL = 'auth/LOGIN_FAIL';
const LOGOUT = 'auth/LOGOUT';
const FLUSH = 'auth/FLUSH';
const SIGNIN = 'auth/SIGNIN';
const FORGOT_PASSWORD_LOAD = 'auth/FORGOT_PASSWORD_LOAD';
const FORGOT_PASSWORD_SUCCESS = 'auth/FORGOT_PASSWORD_SUCCESS';
const FORGOT_PASSWORD_FAIL = 'auth/FORGOT_PASSWORD_FAIL';
const UPDATE_PASSWORD_LOAD = 'auth/UPDATE_PASSWORD_LOAD';
const UPDATE_PASSWORD_SUCCESS = 'auth/UPDATE_PASSWORD_SUCCESS';
const UPDATE_PASSWORD_FAIL = 'auth/UPDATE_PASSWORD_FAIL';
const IS_VALID_TOKEN_LOAD = 'auth/IS_VALID_TOKEN_LOAD';
const IS_VALID_TOKEN_SUCCESS = 'auth/IS_VALID_TOKEN_SUCCESS';
const IS_VALID_TOKEN_FAIL = 'auth/IS_VALID_TOKEN_FAIL';

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  isLogin: false,
  loginErr: null,
  user: null,
  loading: false,
  signupError: null,
  inviteuser: null,
  isSignIn: false,
  forgotErr: null,
  forgotSuccess: null,
  data: null,
  message: null,
  errorMessage: null,
  isValidToken:  null,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('user', action.user);

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('user', null);

    case LOGIN:
      return state
        .set('isLogin', true)
        .set('loginErr', null);

    case LOGIN_SUCCESS:
      return state
        .set('isLogin', false)
        .set('user', action.user);

    case LOGIN_FAIL:
      return state
        .set('isLogin', false)
        .set('loginErr', action.error)
        .set('user', null);

    case LOGOUT:
    case FLUSH: {
      return initialState;
    }

    case FORGOT_PASSWORD_LOAD:
      return state
        .set('isLoad', true)
        .set('forgotErr', null);

    case FORGOT_PASSWORD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('data', action.data)
        .set('forgotSuccess', action.data)

    case FORGOT_PASSWORD_FAIL:
      return state
        .set('isLoad', false)
        .set('forgotErr', action.error)
        .set('data', null)
        .set('forgotSuccess', null)

    case UPDATE_PASSWORD_LOAD :
      return state
        .set('isLoad', true)
        .set('errorMessage', null)
        .set('message', null);

    case UPDATE_PASSWORD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('message', action);

    case UPDATE_PASSWORD_FAIL:
      return state
        .set('isLoad', false)
        .set('errorMessage', action.errorMessage)
        .set('message', null);

    case IS_VALID_TOKEN_LOAD:
      return state
        .set('isLoad', true)
        .set('isValidToken', null)
        .set('errorMessage', null);

    case IS_VALID_TOKEN_SUCCESS:
      return state
        .set('isLoad', false)
        .set('isValidToken', action.data);

    case IS_VALID_TOKEN_FAIL:
      return state
        .set('isLoad', false)
        .set('errorMessage', action.errorMessage);
        
    case SIGNIN:
      return state
        .set('isSignIn', action.data)

    default:
      return state;
  }
}

export const signIn = (data) => async (dispatch) =>{
  dispatch({ type: SIGNIN, data})
}

export const load = (forced) => async (dispatch, getState, api) => {
  // dont call api if user data is in state
  const user = getState().get('auth').get('user');
  if (user && !forced) {
    return;
  }
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/sessions');
    if (res.message) {
      dispatch({ type: LOAD_FAIL, error: res.message });
      return;
    }
    if (res.accessToken) {
      store('authToken', res.accessToken);
      store('refreshToken', res.refreshToken);
    }
    dispatch({ type: LOAD_SUCCESS, user: res });
    dispatch(signIn(false));
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, error });
  }
};

export const login = (email, password) => async (dispatch, getState, api) => {
  dispatch({ type: LOGIN });
  try {
    const res = await api.post('/sessions?jwt=1', { data: { email: email, password:  password} });
    // set authToken to local storage
    store('authToken', res.accessToken);
    dispatch({ type: LOGIN_SUCCESS, user: res });
    dispatch(load(true));
    return res;
  } catch (err) {
    dispatch({ type: LOGIN_FAIL, error: err.message });
  }
};

export const logout = () => (dispatch) => {
  store.remove('authToken');
  store.remove('refreshToken');
  dispatch({ type: LOGOUT });
  dispatch({ type: 'FLUSH' });
  dispatch(signIn(true))
  dispatch(push('/'));
};

  export const forgotPassword = (data) => async (dispatch, getState, api) => {
    dispatch({ type: FORGOT_PASSWORD_LOAD });
    try {
      const res = await api.put('/account/forgot/password/', { data });
      if (res.type !== 'success') {
        dispatch({ type: FORGOT_PASSWORD_FAIL, error: res.message });
        return;
      }
      
      dispatch({ type: FORGOT_PASSWORD_SUCCESS, data: res });
      return res;
    } catch (error) {
      
      dispatch({ type: FORGOT_PASSWORD_FAIL, error: error.message });
    }
  };

  export const authPasswordUpdate = (data) => async(dispatch, getState, api) => {
    dispatch({ type: LOAD });
    try {
      const res = await api.post('/account/update-password', { data });
      dispatch({ type: UPDATE_PASSWORD_SUCCESS, message: res.message });
      return res;
    } catch (error) {
      dispatch({ type: UPDATE_PASSWORD_FAIL, errorMessage: error });
    }
  };

  export const verifyToken = (data) => async(dispatch, getState, api) => {
    dispatch({ type: IS_VALID_TOKEN_LOAD });
    try {
      const res = await api.post('/account/verify-token', { data });
      if (res.message) {
        dispatch({ type: IS_VALID_TOKEN_FAIL, errorMessage: res });
        return;
      }
      dispatch({ type: IS_VALID_TOKEN_SUCCESS, isValidToken: res });
      return res;
    } catch (error) {
      dispatch({ type: IS_VALID_TOKEN_FAIL, errorMessage: error });
    }
  }


// WEBPACK FOOTER //
// ./src/redux/modules/auth.js